<template>
    <div>
        <div>
            <form name="reqDRMOKForm"  action="#" method="post" >
                <input type="hidden" name="req_info" v-model="reqInfo">
                <input type="hidden" name="rtn_url"  v-model="returnURL">
                <input type="hidden" name="cpid"     v-model="cpId">
            </form>
        </div>
        <v-dialog/>
    </div>
</template>

<script>
import { publicAuthSend } from '@/api/step3/identificationVerfication'
export default {
    name: 'CallNormalAuthPop',
    data() {
        return {
            cpId:'',
            reqInfo:'',
            returnURL:'',
            custNm: '',
            custPersId: '',
            custType: '',
            onetMblAppfNo: ''
        }
    },
    created() {
        this.getInfo();
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : 범용공인인증 정보
         **/
        getInfo() {

            var locationUrl = location.href;
            locationUrl = locationUrl.split('//');
            locationUrl = locationUrl[1].substr(0,locationUrl[1].indexOf('/'));
          
            publicAuthSend(opener.normalauthdata).then(res => {
                let url = res.data.dsReq.reqUrl
                if(locationUrl.indexOf("stg") != -1) {
                    url ="https://"+ locationUrl+"/ococ/datacapture/auth/resultNormalPop";//test URL
                }else if( locationUrl.indexOf("local") != -1){
                    url = "http://localhost:8081/ococ/datacapture/auth/resultNormalPop";//test URL
                }
              
                this.cpId = res.data.dsReq.cpId
                // 서버의 API를 호출하는 URL
                this.returnURL = res.data.dsReq.retUrl
                this.reqInfo = res.data.dsReq.encReqInfo
                if(res.data.dsRsltInfo.rsltCd!=="FAIL"){
                    this.$nextTick(()=>{
                        document.reqDRMOKForm.action = url
                        document.reqDRMOKForm.submit()
                    })
                }else{
                    alert(res.data.dsRsltInfo.rsltMsg)
                    window.close()
                }
            })
        },
    },
}
</script>

<style scoped>

</style>